<div
  class="bg-neutral-white s-min-w-70 s-p-3 border-left border-clr-primary-brand-color card-variant"
>
  <div
    class="d-flex flex-column align-items-center flex-wrap"
  >
    <ng-content select="[slot=card-title]">
    </ng-content>
    <ng-content select="[slot=card-value]">
    </ng-content>
  </div>
</div>